import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import Offer from '../../entities/booking/offer';

interface OfferState extends ListState<Offer>{
    editOffer:Offer
}
class OfferMutations extends ListMutations<Offer>{

}
class VerifyOfferModule extends ListModule<OfferState,any,Offer>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Offer>(),
        loading:false,
        editOffer:new Offer()
    }
    actions={
        async getAll(context:ActionContext<OfferState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Offer/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Offer>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async get(context:ActionContext<OfferState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Offer/Get?Id='+payload.id);
            return reponse.data.result as Offer;
        },
        async verifyOffer(context:ActionContext<OfferState,any>,payload:any)
        {
            await Ajax.post('/api/services/app/Offer/VerifyOffer',payload.data);
        }
    };
    mutations={
        setCurrentPage(state:OfferState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:OfferState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:OfferState,offer:Offer){
            state.editOffer=offer;
        }
    }
}
const verifyOfferModule=new VerifyOfferModule();
export default verifyOfferModule;